import React, { Component } from 'react';
import DailyNewsService from '../../../services/daily-news';
import shareService from '../../../services/share';
import TwitterService from '../../../services/twitter';
import './auto-post.css';

const TagsBank = ['javascript', 'frontend', 'webdev', 'typescript', 
  'angular', 'reactjs', 'vuejs', 'golang', 'programming', 'reactnative', 
  'graphql', 'kotlin', 'flutter', 'html', 'css', 'python', 'java', 'machinelearning',
  'docker', 'php', 'ux', 'aws', 'gamedev',];

class AutoPost extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false, 
    };

    this.post(props);
  }

  componentDidUpdate(props) {
    // this.post(props);
  }

  calcTwitterTextLength(twitterText, url) {
    // length of twitter link is 24 + 5 gap
    return twitterText.length - url.length + 24 + 5; 
  }

  setTwitterText = (event) => {
    const twitterText = event.target.value;
    const newLength = this.calcTwitterTextLength(twitterText, this.state.postbackUrl);
    if (newLength > 280) return;

    this.setState({
      twitterText,
      twitterTextLength: newLength,
    });
  };

  onSaveTweet = () => {
    const { twitterText, _id } = this.state

    TwitterService.generateTweetItTweet(twitterText, _id)    
      .then(() => {
        window.location.href = 'https://dormoshe.io';
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        
        try {
          this.setState({ isError: true, errorMessage: JSON.stringify(errorMessage) });  
        }
        catch(err2) {
          this.setState({ isError: true, errorMessage: JSON.stringify(errorMessage) });
        }
      });

    const { postbackUrl, isTagIt3 } = this.state;
    if (!isTagIt3) return;

    // add to tagIt3 and top priority
    const url = `${postbackUrl}?todoist=tagit3&priority=4`; // 4 is urgent (like 1 in app)
    DailyNewsService.addFuturePost(url)    
      .then(() => {})
      .catch(() => {});
  };

  getTwitterShareInitialText = ({ title, twitterTags, twitterRefs, postbackUrl, }) => {
    twitterTags = twitterTags.filter(tag => tag !== 'react' && tag !== 'vue').map(tag => tag.split(' ').join(''));
    const { twitterTitle, twitterTags:restTwitterTags } = shareService.getTwitterTitleAndTags(title, twitterTags, 0);

    let fullTweetText = twitterTitle;
    if (twitterRefs && twitterRefs.length > 0) {
      fullTweetText += ` @${twitterRefs.join(' @')}`;
    }

    fullTweetText += ` ${postbackUrl}`;

    fullTweetText += restTwitterTags.length > 0 ? ` #${restTwitterTags.join(' #')}` : '';

    return fullTweetText;
  }

  post(props) {
    let newsUrl = props.match.params[0];
    const queryParams = props.location.search;
    newsUrl += queryParams ? queryParams : '';

    DailyNewsService.postAutomatically(newsUrl)
      .then((news) => {
        const twitterText = this.getTwitterShareInitialText(news);
        const newLength = this.calcTwitterTextLength(twitterText, news.postbackUrl);
        const tagsBank = TagsBank.filter(tag => (news.twitterTags || []).indexOf(tag) === -1);
        const isTagIt3 = this.isTagIt3(tagsBank);

        this.setState({ 
          ...news,
          twitterText,
          twitterTextLength: newLength,
          tagsBank,
          isTagIt3,
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: JSON.stringify(errorMessage) });
      });
  }

  isTagIt3 = (tagsBank) => {
    return tagsBank.indexOf('angular') === -1 || (tagsBank.indexOf('typescript') === -1 && tagsBank.indexOf('reactjs') > -1);
  };

  addTag = (newTag) => {
    this.setState(({ twitterTextLength, twitterText, tagsBank, }) => {
      const newLength = twitterTextLength + newTag.length + 2; // space and #
      if (newLength > 280) return;

      const updatedTagsBank = tagsBank.filter(tag => tag !== newTag);

      return {
        twitterText: `${twitterText} #${newTag}`,
        twitterTextLength: newLength,
        tagsBank: updatedTagsBank,
        isTagIt3: this.isTagIt3(updatedTagsBank),        
      }
    });
  };

  render() {    
    let body = 'Processing...';

    const { postbackUrl, twitterText, isSuccess, twitterTextLength, tagsBank, } = this.state;    
    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }
    else if (isSuccess) {
      body = 'ok';
    }
    else if (postbackUrl) {
      body = (
        <div>
          <div><a href={postbackUrl}>{postbackUrl}</a></div>
          
          <div>
            <textarea 
              value={twitterText} 
              onChange={this.setTwitterText}
              rows='8'
              cols='40' />              
          </div>
          <div>{ twitterTextLength } / 280 </div>

          <div>
            { 
              tagsBank.map(tag => (
                <input type='button' value={ tag } onClick={() => this.addTag(tag)}/>
              )) 
            }
          </div>
          
          <div>
            <input 
              type='button' 
              value='Save' 
              onClick={this.onSaveTweet}
              style={{ color: 'white', background: `${this.state.isTagIt3 ? 'green' : 'blue'}`, marginTop: '10px', height: '50px', width: '100px', }}
            />
          </div>
        </div>
      );
    }

    return (
      <section className='regular-page'>
        {body}
      </section>
    );
  }
}

export default AutoPost;
